<template>
  <div class="relative" style="height: auto;">
    <AppHeader />
    <router-view></router-view>

    <div v-if="$route.path === '/'" class="header">
  <div class="bg-black text-white flex justify-center items-center">
    <div class="text flex flex-col items-start pt-3 pr-1 pb-3">
      <div class="flex items-center">
        <i class="far fa-thumbs-up text-green-500 mr-2"></i>
        <p class="text-center font-semibold text-sm lg:text-base">Rated 9.8/10 - Over 260+ Reviews</p>
      </div>
      <div class="star-line flex justify-center items-center">
        <i class="fa fa-star text-yellow-500"></i>
        <i class="fa fa-star text-yellow-500"></i>
        <i class="fa fa-star text-yellow-500"></i>
        <i class="fa fa-star text-yellow-500"></i>
        <i class="fa fa-star text-yellow-500"></i>
      </div>
    </div>
  </div>
</div>

<!-- First Hero Section -->
<div class="hero-background pt-4 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative">
  <div class="max-w-3xl mx-auto space-y-10">
    <div class="text-white">
      <div class="flex flex-col items-center mb-2"> <!-- mb-2 adds a little space below this div -->
        <!---<div class="bg-white bg-opacity-80 p-2 rounded">
          <img src="@/assets/logo-invest.png" alt="Company Logo" class="h-8 mt-1"> 
        </div> -->
      </div>

      <h2 class="mt-6 text-3xl sm:text-5xl font-extrabold text-shadow">
        Sell Yer Hoose wi' Nae Delay, A Fast Cash Offer Comes Yer Way!
      </h2>

      <!-- Inserting an image under the title -->
      <img src="@/assets/scottish-house-bagpipes.png" alt="Descriptive Alt Text" style="height: auto;">
      <div class="flex justify-between">
        <!-- Content here remains the same -->
      </div>
    </div>
    <!-- More content here -->
  </div>
</div>
<!-- End First Hero Section -->


    <div v-if="$route.path === '/'" class="header-container flex flex-col items-center bg-cover bg-center relative" :style="`background-image: url(${headerImageUrl})`" >
    
    <div class="overlay absolute inset-0 bg-beige-500 opacity-90"></div>      
      <div class="flex flex-col items-center z-10" :class="{ 'hidden': showQuiz || showContact }">
        <div class="key-points-container text-left sm:text-center pt-0 sm:pt-3 md:pt-5 md:mt-1 px-5 sm:px-0">
          
         <!---- <div class="px-4 sm:px-6 text-center text-sm sm:text-2xl text-green-600 font-bold bg-green-100 mt-2 sm:mt-4">
            Scotland's Biggest Property Buyer
          </div> -->

          <a href="#addressForm" 
   class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-2 mx-auto text-center text-xl block max-w-xs md:mt-1"
   v-if="!$route.path.startsWith('/articles/') && $route.path !== '/thank-you'">
  Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i>
</a>

          <h1 class="text-xl md:text-3xl font-extrabold text-black text-center pt-3 pb-0 sm:text-center px-2 tracking-wider">
            At Invest in Scottish Properties, we don't muck aboot – we get things done!
        </h1>

          <ul class="mt-4 flex space-x-0 sm:space-x-4 md:space-x-6 justify-start sm:justify-center flex-wrap text-left text-black px-2 md:px-12 lg:px-80">
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> Scotland's No. 1 cash buying name
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> Our funds are ours, nae faff
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> Nae waitn around for lenders
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> A fair price offered quicker than ye can say "haggis"
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> No agent fees, nae hassle, nae bother
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> It disnae matter whit state yer hoose is in
            </li>
            <li class="flex items-center mb-2 px-2 sm:px-0 pr-6">
              <i class="fas fa-check text-green-500 mr-2"></i> We'll buy it, nae questions asked!
            </li>
          </ul>
        </div>

        <div class="bg-beige-200 bg-opacity-80 rounded-lg shadow px-6 py-4 my-4 max-w-4xl text-center mr-2 ml-2">
                <div class="flex flex-col items-center mb-2"> <!-- mb-2 adds a little space below this div -->
        <div class="bg-white bg-opacity-80 p-2 rounded"> <!-- Adds white background with 50% opacity, padding, and rounded corners -->
          <img src="@/assets/logo-invest.png" alt="Company Logo" class="h-8 mt-1"> <!-- Adjust size as needed -->
        </div>
      </div>
      <p class="text-black font-medium text-sm md:text-lg">
        We're a family-run outfit and we Scots take care of our own. Whether yer hoose is a bit worn around the edges or in tip-top shape, we're here tae make sure ye get a fast, fair deal. And let’s be honest, who wants tae be stuck in limbo, waitin' for a sale?
      </p>
      <p class="text-black font-medium text-sm md:text-lg mt-2">
        So, don't dae yersel' in with worry. We'll make the whole process as smooth as a wee dram of whisky. Ye'll be sittin' back, feet up, before ye know it!
      </p>
    </div>

        <AddressForm id="addressForm" @addressSelected="onAddressSelected" class="w-full px-4 sm:w-1/2 sm:px-0 mt-1" />

<div class="mt-4 small-device-text">
  <div class="w-full sm:max-w-sm mx-auto text-sm text-gray-700 pb-10">
    <p class="text-xs font-bold mb-2">
  <span class="text-red-500 mr-1">&#9888;</span>
  We understand that each property has unique circumstances. Our team thoroughly evaluates every property based on its individual merit.
</p>
          </div>
        </div>
      </div>

      <div class="flex flex-col items-center pt-10 mx-4 justify-start z-10" :class="{ 'hidden': !showQuiz }">
        <div class="text-xl sm:text-3xl font-bold text-black mb-8">
          Tell us about your property...
        </div>


        <QuizForm @completed="onQuizComplete" />
        <div class="sm:max-w-sm mx-auto text-sm text-black pt-5 pb-10" style="font-size: 12px;">
          <span class="text-grey-500 mr-1">&#9888;</span>
          This information helps us tailor our offer to meet your specific needs.
        </div>
      </div>

      <div class="flex flex-col items-center pt-10 justify-start z-10 pb-10" :class="{ 'hidden': !showContact }">
        <ContactForm :address-data="addressData" 
                      :gclid="gclid"
                      :quiz-data="quizData" 
                      :utmCampaign="utmCampaign" 
                      :utmSource="utmSource" 
                      :utmMedium="utmMedium"
                      :utmMatchType="utmMatchType"
                      :utmKeyword="utmKeyword" 
                      :utmDevice="utmDevice"
                      :seoQuery="seoQuery" 
                      :creativeId="creativeId" />
      </div>
    </div>

    <div v-if="$route.path === '/contact-us' || $route.path === '/' || $route.path === '/how-we-work' || $route.path === '/about-us'" class="countdown-container py-4 bg-gray-300">
        <countdown-timer />
    </div>

    <div v-if="$route.path === '/contact-us' || $route.path === '/' || $route.path === '/how-we-work' || $route.path === '/about-us'" lass="bg-white-100">
          <div class="mx-auto max-w-7xl px-6 py-4">
          <div class="flex flex-col md:flex-row justify-between items-center py-4 px-4">
          <div class="w-full md:w-1/4 flex md:justify-center items-center px-6 py-4 md:py-0">
            <i class="fas fa-check-circle text-indigo-800 pr-6 text-4xl"></i>
          <div>
          <h2 class="font-bold text-lg">Cash Ready</h2>
          <p>Well-established multi-million pound company</p>
          </div>
          </div>
          <div class="w-full md:w-1/4 flex md:justify-center items-center px-6 py-4 md:py-0">
            <i class="fas fa-check-circle text-indigo-800 pr-6 text-4xl"></i>
          <div>
          <h2 class="font-bold text-lg">Family Run</h2>
          <p>We've been buying property for over 30 years</p>
          </div>
          </div>
          <div class="w-full md:w-1/4 flex md:justify-center items-center px-6 py-4 md:py-0">
            <i class="fas fa-check-circle text-indigo-800 pr-6 text-4xl"></i>
          <div>
          <h2 class="font-bold text-lg">Best Prices Paid</h2>
          <p>We pay fair prices for property</p>
          </div>
          </div>
          <div class="w-full md:w-1/4 flex md:justify-center items-center px-6 py-4 md:py-0">
            <i class="fas fa-check-circle text-indigo-800 pr-6 text-4xl"></i>
          <div>
          <h2 class="font-bold text-lg">No Pressure</h2>
          <p>We don't do any hard selling</p>
          </div>
       </div>
    </div>
  </div>
</div>
</div>



  <div v-if="($route.path.startsWith('/landerv1/') || $route.path.startsWith('/landerv2/') || $route.path.startsWith('/landerv3/') || $route.path === '/contact-us' || $route.path === '/' || $route.path === '/how-we-work' || $route.path === '/about-us' || $route.path === '/thank-you')" class="bg-green-100 p-4 rounded-lg">
  <div class="flex items-center justify-between mb-4 max-w-3xl mx-auto">
    <img src="@/assets/rfline.svg" alt="Logo" class="object-contain w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40 xl:w-48 xl:h-28 mr-4">
    <div class="text-right font-bold">
      <p class="text-green-500 font-bold text-xs md:text-base">100% recommended</p>
      <p class="text-gray-500 text-xs md:text-base">Rating 9.8/10</p>
      <p class="text-gray-500 text-xs md:text-base">260 reviews since 2014</p>
    </div>
  </div>
  <p class="text-center font-bold mb-4 max-w-3xl mx-auto">
    Over the years we have helped 1000s of people with our quick property cash buying service.
      </p>
  <div class="bg-white p-4 rounded-lg shadow-md mb-4 max-w-3xl mx-auto">
    <i class="fas fa-comments text-blue-500 mr-2"></i>
    <p class="font-medium text-sm md:text-base">{{ reviews[currentReview].text }}</p>
  </div>
  <div class="flex justify-between max-w-3xl mx-auto">
    <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="previousReview">Previous</button>
    <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="nextReview">Next</button>
  </div>

<a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold text-center py-2 px-4 rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs" v-if="!$route.path.startsWith('/articles/') && $route.path !== '/thank-you'">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>

</div>

  <div v-if="$route.path === '/contact-us' || $route.path === '/' || $route.path === '/how-we-work' || $route.path === '/about-us'" class="guaranteed-offer">
  <h2 class="font-bold mb-8 text-center" style="font-size: 1.5rem;">Want a Guaranteed Offer?</h2>
      <p class="px-4 mb-4">
        With no fees, complete flexibility on your moving date, 100% confidentiality, no stress and no estate agents! We provide speed, certainty, simplicity.
      </p>
      <div class="offer-steps">
        <div class="step">
          <i class="fas fa-comments chat-bubble-icon"></i>
          <p>Tell us about your property</p>
        </div>
        <div class="step">
          <i class="fas fa-handshake cash-offer-icon"></i>
          <p>Accept our cash offer</p>
        </div>
        
        <div class="step">
          <i class="fas fa-university bank-icon"></i>
          <p>Cash in the bank when you need it</p>
        </div>
      </div>
      <p class="px-4 mb-4">
        Our service is simple, stress-free, giving your peace of mind.
      </p>

      <a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>

    </div>



<div v-if="!($route.path.startsWith('/landerv1/') || $route.path.startsWith('/landerv2/') || $route.path.startsWith('/landerv3/') || $route.path.startsWith('/landerv2/') || $route.path.startsWith('/articles/') || $route.path.startsWith('/privacy-policy') || $route.path.startsWith('/terms-of-use') || $route.path.startsWith('/cookies-policy') || $route.path.startsWith('/thank-you'))" class="bg-blue-800 full-width flex justify-center items-center text-white p-4">
  <div class="max-w-3xl p-3">
    <h2 class="text-2xl font-bold mb-8 text-center">Are you searching for a reliable home-buying company?</h2>
    <p class="px-4 mb-4">Tired of browsing through endless lists of companies that buy houses?</p>
    <p class="px-4 mb-4">Seeking a fair price for your home without the stress of navigating the open market? How about a seamless and hassle-free property sale?</p>
    <p class="px-4 mb-4">Look no further! Sell House Fast Scotland is here to help. With our readily available funds, we can purchase your home today.</p>
    <p class="px-4 mb-4">Selling your property on the open market can be a daunting process filled with challenges and uncertainties. By choosing to sell your property to us, you'll enjoy a smooth transaction without any unexpected surprises.</p>
    <p class="px-4 mb-4">If our offer meets your expectations, once accepted, you can rest assured knowing that your house is sold.</p>
    <p class="px-4 mb-4">As a cash buyer, we offer you complete peace of mind and a guaranteed house sale, ensuring a stress-free experience for you, the seller.</p>

    <a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 text-center rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>


  </div>
</div>

<div v-if="$route.path.startsWith('/landerv1/') || $route.path.startsWith('/landerv2/')" class="bg-blue-800 full-width flex justify-center items-center text-white p-4">
  <div class="max-w-3xl p-3">
    <h2 class="text-2xl font-bold mb-8 text-center">Are you searching for a reliable home-buying company?</h2>
    <p class="px-4 mb-4">Tired of browsing through endless lists of companies that buy houses?</p>
    <p class="px-4 mb-4">Seeking a fair price for your home without the stress of navigating the open market? How about a seamless and hassle-free property sale?</p>

    <a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>

  </div>
</div>




<div v-if="$route.query.show_comp === 'yes' && !($route.path.startsWith('/thank-you') || $route.path.startsWith('/articles/'))" class="bg-gray-100 flex items-start justify-center p-8">
  <div class="bg-white p-6 rounded-lg shadow-lg lg:flex lg:items-center w-full max-w-3xl">
    <div class="mt-2 lg:mt-0 lg:w-full">
      <div class="w-full max-w-3xl">
        <h2 class="text-2xl font-bold mb-4 text-center">Sell House Fast Scotland vs. Estate Agents</h2>
        <p class="text-center mb-4">Opt for Sell House Fast Scotland and enjoy a seamless, stress-free home sale. We manage all aspects of the transaction, including legalities, without third-party involvement. Experience the advantages of working with us over traditional estate agents.</p>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full border-collapse small-device-table">
        <thead>
          <tr>
            <th class="py-2 font-bold text-left border-b-2 border-gray-200">Sales Process</th>
            <th class="py-2 font-bold text-right border-b-2 border-gray-200">Sell House Fast Scotland</th>
            <th class="py-2 font-bold text-right border-b-2 border-gray-200">Estate Agents</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">Duration</td>
            <td class="px-2 py-2 text-right bg-green-200 border-b border-gray-200">7 Days</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">5-7 Months</td>
          </tr>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">Market Values</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£100,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£100,000</td>
          </tr>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">Agreed Sales Price</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£80,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£90,000</td>
          </tr>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">After Agent Fees</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£80,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£88,000</td>
          </tr>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">After Conveyancing</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£80,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£86,000</td>
          </tr>
          <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">After Housing Costs</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£80,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200">£82,000</td>
            </tr>
            <tr>
            <td class="px-2 py-2 text-left border-b border-gray-200">After Monthly Bills</td>
            <td class="px-2 py-2 text-right border-b border-gray-200 font-bold">£80,000</td>
            <td class="px-2 py-2 text-right border-b border-gray-200 font-bold">£80,000</td>
            </tr>
            </tbody>
            <tfoot>
                <tr>
                  <td colspan="3" class="px-2 py-2 text-center text-sm italic small-device-table">
                    *This is a representative example; we typically offer up to 80% of the property market value for a cash purchase completed in 7 days.
                    <a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>

                  </td>
                </tr>
              </tfoot>
          </table>
        </div>
     </div>
  </div>
</div>

<div v-if="!$route.path.startsWith('/articles/') && !$route.path.startsWith('/landerV1/') && !$route.path.startsWith('/landerV2/') && !$route.path.startsWith('/privacy-policy') && !$route.path.startsWith('/cookies-policy') && !$route.path.startsWith('/terms-of-use') && !$route.path.startsWith('/thank-you')" class="bg-gray-200 flex items-start justify-center p-8">
  <div class="bg-white p-6 rounded-lg shadow-lg text-center max-w-3xl mx-auto">
    <h2 class="text-2xl font-bold mb-4">We Can Help Under Any Circumstances</h2>
    <p class="mb-4">We can help anybody facing debt, mortgage arrears, repossession or bereavement, or matrimonial problems within a few hours.</p>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Matrimonial
      </div>
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Mortgage Arrears
      </div>
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Retirement
      </div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Inheritance
      </div>
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Facing Repossession
      </div>
      <div class="flex items-center justify-start">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        And more...
      </div>
    </div>
    <a href="/#addressForm" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-auto text-xl block max-w-xs">Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i></a>
  </div>
</div>


<!-- FAQs Section -->
<div id="app" class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" v-if="!$route.path.startsWith('/articles/') && !$route.path.startsWith('/landerV1/') && !$route.path.startsWith('/landerV2/') && !$route.path.startsWith('/privacy-policy') && !$route.path.startsWith('/cookies-policy') && !$route.path.startsWith('/terms-of-use') && !$route.path.startsWith('/thank-you')"  >
  <div class="text-center">
    <h2 class="text-3xl font-bold text-gray-900">FAQs</h2>
  </div>
  <div class="mt-8">
    <dl class="space-y-6">
      <div v-for="(item, index) in faqs" :key="index" class="space-y-2">
        <dt class="cursor-pointer px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors duration-200" @click="toggle(index)" :class="{'text-gray-900': item.isOpen, 'text-gray-700': !item.isOpen}">
          <div class="flex justify-between items-center">
            {{ item.question }}
            <svg :class="{'rotate-180': item.isOpen}" class="inline-block w-4 h-4 transition-transform duration-200" viewBox="0 0 24 24">
              <path d="M19 9l-7 7-7-7" stroke="currentColor" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </dt>
        <dd v-show="item.isOpen" class="text-gray-600 px-4 py-2 bg-gray-100">
          {{ item.answer }}
        </dd>
        
      </div>
      <a
  href="/#addressForm"
  class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded shadow-lg mt-6 mx-auto text-center text-xl block max-w-xs"
  v-if="!$route.path.startsWith('/articles/') && $route.path !== '/thank-you'"
>
  Get a Free Cash Offer <i class="fas fa-arrow-right ml-2"></i>
</a>


    </dl>
  </div>
</div>







<div v-if="!$route.path.startsWith('/articles/')" class="bg-gray-200 py-8">
  <div class="max-w-3xl mx-auto">
    <h2 class="text-2xl font-bold mb-4 text-center">We have advertised in:</h2>
    <div class="flex flex-wrap justify-center items-center">
      <div class="mx-4 my-2">
        <img src="@/assets/logo1.png" alt="Logo 1" class="h-12">
      </div>
      <div class="mx-4 my-2">
        <img src="@/assets/logo2.png" alt="Logo 2" class="h-12">
      </div>
      <div class="mx-4 my-2">
        <img src="@/assets/logo3.png" alt="Logo 3" class="h-12">
      </div>
      <div class="mx-4 my-2">
        <img src="@/assets/logo4.png" alt="Logo 4" class="h-12">
      </div>
      <div class="mx-4 my-2">
        <img src="@/assets/logo5.png" alt="Logo 5" class="h-12">
      </div>
      <div class="mx-4 my-2">
        <img src="@/assets/logo6.png" alt="Logo 6" class="h-12">
      </div>
    </div>
  </div>
</div>

<footer class="bg-gray-900 text-white py-8">
  <div class="max-w-3xl mx-auto flex flex-col items-center">
    <img src="@/assets/shf-logo-white.png" alt="Sell House Fast Scotland Logo" class="h-12 mb-4">
    <nav class="mb-4">
      <ul class="flex">
        <li class="mr-4">
          <a href="/privacy-policy">Privacy Policy</a>
        </li>
        <li class="mr-4">
          <a href="/terms-of-use">Terms of Use</a>
        </li>
        <li class="mr-4">
          <a href="/cookies-policy">Cookie Policy</a>
        </li>
      </ul>
    </nav>
    <div class="flex items-center justify-center mb-4">
      <p class="text-center py-2 text-sm sm:text-base">We adhere to strict codes of conduct as set out by</p>

    </div>
    <div class="flex pb-2">
      <img src="@/assets/img2.png" alt="Approved by organization" class="h-8 mx-2">
      <img src="@/assets/img3.png" alt="Approved by organization" class="h-8 mx-2">
      <img src="@/assets/img4.png" alt="Approved by organization" class="h-8 mx-2">
    </div> 
    <p class="text-center py-2 px-4 text-sm sm:text-base">&copy; 2024 Sell House Fast Scotland, a trading style of Invest In Scottish Properties Ltd. All rights reserved.</p>
    <p class="text-center py-2 text-xs sm:text-sm">Mailing address: Suite 2/3 48 West George Street, Glasgow, G2 1BP.</p>
    <p class="text-center text-xs sm:text-sm text-gray-500 px-4 py-2">
      Disclaimer: The information provided on this website, including any financial or real estate advice, is for general informational purposes only and should not be considered as professional advice. Invest in Scottish Properties Ltd and Sell House Fast Scotland are not responsible for any actions taken based on the information provided on this website. Visitors are encouraged to seek professional advice before making any financial or real estate decisions. While we strive to keep the information accurate and up-to-date, we make no guarantees about the completeness, accuracy, or reliability of the information on this site. Invest in Scottish Properties Ltd will not be held liable for any errors, omissions, or delays in the information provided, or for any losses, injuries, or damages arising from its display or use. All information is provided on an as-is basis.
    </p>

  </div>
</footer>


</template>



<script>
import AppHeader from "@/components/Header.vue";
import AddressForm from "./components/AddressForm.vue";
import QuizForm from "./components/QuizForm.vue";
import ContactForm from "./components/ContactForm.vue";
import CountdownTimer from "./components/CountdownTimer.vue";


export default {
  components: {
    AppHeader,
    AddressForm,
    QuizForm,
    ContactForm,
    CountdownTimer,
  },
  data() {
    return {
      addressData: {
        street: "",
        postcode: "",
      },
      currentReview: 0,
      reviews: [
      {
    "text": "I was having to move due to health reasons and was looking for a quick sale. I was very impressed with what the company offered and I was so happy they took ownership of the sale and the legal costs. This really took the pressure off me. I was so glad to have went with them as the property was sold within a week. The aftercare provided was also exceptional. Both Laura and Jake were a pleasure to deal with. I'd definitely recommend them to others."
  },
  
  {
    "text": "Had an excellent experience in selling a house we had inherited. Laura was amazing, agreed the price there and then at first meeting. Everything went like clockwork and within the agreed timescales. Laura and her son Jake were extremely friendly and professional and I will have no hesitation in recommending their company to anybody either friends, family or within my place of work. A five star service from a family run business that are sympathetic to people's circumstances - a rarity nowadays. Also want to say, unlike other companies out there, there was no attempt to try and reduce the agreed price - what they agree to pay, they pay."
  },
  
  {
    "text": "I cannot express my gratitude enough to Laura and the company. The whole process of selling our house was straightforward. From the very start to the end we felt supported and knew that we could trust Laura implicitly. I cannot thank Laura and her families business enough for dealing with our situation swiftly. I would highly recommend using this company not only to family and friends but anyone reading this. These are professional,trustworthy and caring people, so leave your doubts behind!"
  },
  {
    "text": "I was delighted with Invest in Scottish Properties. I found them to be professional, prompt, helpful and friendly. They made a task that I expected to be stressful, easy and straightforward. Now, three weeks after the conclusion of the sale I can hardly believe it is all done. Everything was so simple."
  },
  {
    "text": "Difficult to know where to begin. Dealing with We invest in Scottish properties, in particular Laura, was one the best decisions I have ever made. I have had nothing but heartbreak for the best part of 2 years trying to sell my house. I got in touch with Laura and within the first 2 minutes of our phone call, in my heart I knew that she was the right person to help me sell my property. She answered every single question and I explained to her the severe anxiety I had about everything. She even came to my property to sit and talk me through every single step. We invest in Scottish properties genuinely have their customer’s best interests at heart and no job is too big or small. I can’t possibly thank you enough for giving myself and my children the new start in life we needed so desperately. I’m crying just typing this. I will never, ever forget the difference you’ve made to our lives. Thank you so so much."
  },
  {
    "text": "My dealings with Laura regarding selling my property were very professional and helpful at all stages in the selling of my property. Laura kept me up to date at all stages. I would highly recommend this company for anyone looking for a professional service with regards selling their property."
  },
  {
    "text": "Great Service, put an enquiry in and received a call from Laura a few hours later talking me through the process. After a few quick questions a price was agreed. Laura kept in touch with me daily, keeping me updated as to what was happening. All in all a very professional service. Everything handled efficiently and the whole process felt incredibly easy. Thank you very much Laura"
  },
  {
    "text": "I found the whole experience of selling the property very smooth. Laura was very easy to contact throughout the whole process and the offer I received was acceptable due to the condition of the property and its age. I also dealt with her son Jake on two occasions and he was very helpful at the initial visit to view the property during the survey and again on the 2nd visit to collect the keys after the sale was completed. I would have no hesitation to recommend Laura or Jake to anybody wishing to sell a problem property in the future.\n\nA first-class service all round.\n\nThank You,\n\nClaire"
  },
  {
    "text": "Invest in Scottish properties were completely amazing. From start to finish, Laura was in constant contact by telephone. I can’t praise Laura enough; everything has gone nice and smooth. They are totally professional as well as considerate. They answer all questions and have the customer (myself) in mind at every step of the way. I would recommend them to everyone for a quick and efficient sale. Well done to Laura and your team, can’t thank you enough. Keep up the excellent work you do.\n\nThanks, John"
  },
  {
    "text": "It was a pleasure to deal with the team at Invest in Scottish Properties Quick Buyers Scotland - Sales, from start to finish. Laura was clear and easy to talk to. Throughout the whole process, everything happened as promised during the initial phone call and payment arrived in my account on time. Honest, trustworthy, and professional."
  },
  {
    "text": "Great experience from start to finish. Fair price agreed early on. Lots of communication throughout."
  },
  {
    "text": "I cannot fault this company even a little. From start to finish, they were on hand to offer an ear or advice on things I would need to do before selling the house. I also had no contact with the other half selling the house and Laura couldn't be more helpful in assisting with communication so I didn't have to. Which was such a relief. From start to finish, they were open and honest and with every new step in the process, they called ahead, discussed what would happen, and how long it would take. They showed up at the time they said and was out when they said also. I have two young kids and didn't have anywhere to go, and Laura and Jake helped by discussing with me a time scale to suit our needs and check in all the time to make sure me and the kids were ok and if we needed any extra time, which again I was thankful for. I would highly recommend Laura and Jake to help sell your home, first-class service."
  },
  {
    "text": "I was looking to sell my rental property quickly and found 'Invest In Scottish Property' in an internet search.\n\nI phoned them and spoke to Laura who discussed things with me and quickly made me a reasonable offer. Laura explained clearly the steps of the sale and costs involved. She also explained that there was no outlay on my part for the sale as her company would pay for the required reports and that the house offer included a further £1000 towards my solicitor fees. She then agreed to give me some time to think the offer over and agreed to call me back a few days later at an agreed time. She also emailed me the offer, with details about the company and process like we discussed.\n\nLaura then called me back as agreed and I accepted her offer. She was then extremely helpful with arranging a solicitor for me to use, as I didn’t have one, and then throughout the period of the sale, she kept in touch with me to keep me informed of progress.\n\nThe sale was then completed within 3 weeks as agreed.\n\nThe whole process was very quick and easy. I could not have asked for more from 'Invest In Scottish Property' and would highly recommend them."
  },
  {
    "text": "Relatively stress-free process. Laura kept in constant touch with updates regarding the progress of sale and was very understanding of our circumstances. Young Jake is a very nice lad and very helpful. Turned up on time during the initial viewing. I would recommend this company to anyone looking for a quick compassionate sale."
  },
  {
    "text": "The experience dealing with Invest in Scottish Properties Quick Buyers Scotland - Sales was fantastic. At first, I was a little scared, but Laura and her son put my mind at ease, and I am grateful I found Laura as this is my first time selling my property. I highly recommend this company to anyone looking to sell their property."
  },
  {
    "text": "The service was exceptional, and from start to finish, the property was sold, and the money was in the bank in 2 weeks!!! My partner moved in with me two years ago, and since then, his flat in Glasgow had remained empty and uninhabited. The area in which it was had at one time been desirable but had over the years become neglected and unmaintained, and the property itself most certainly required a considerable amount of remodernisation. I have Multiple Sclerosis, and the trips to and from the property to check it was safe and secure were becoming increasingly difficult, particularly as now we were living 20 miles away. We hummed and hawed and spoke to various estate agents, received a few valuations, but really felt we did not have the money to spend on getting the property desirable for buyers, paying for home reports, and estate agency fees, or the time to hold viewings and had given up on the goal of getting the property sold before our wedding in September. My mum had seen an advert for a company that offered a worry-free service, that stated they bought houses regardless of the condition, but could not remember the name. Both myself and my partner knew (or thought we knew at this point!) the type of company this would be and did not hold out much hope, expecting an unfair offer and many small print add-ons for hidden finances, clauses, and poor customer service, as well as a pushy salesman to add to the stress. However, lying in bed one night, I googled the type of service my mum had described, and I contacted 3 companies requesting a call back. The next morning my phone rang, and I found myself spilling my heart out to a wonderful woman, who listened to me, empathised, and chatted openly about her company, a family-run business, and told me exactly the service they could provide, stating that if we wanted a quick and easy sale, the process could be completed within a fortnight. She asked me to give her a couple of hours to view the area the flat was in and advised me to do the same, offering different sites to look on, to get an idea of similar properties in the area, the condition they were in, and the prices they were asking for. We did, as did she, and all came to the agreement that our property was in a much poorer condition than many, and also better than others, and she also guided us on looking into how long other properties had been on the market for. We really felt she had given us already a huge amount of guidance and advice and was clearly very knowledgeable on every aspect of the housing market. She asked us to go and have a chat with each other, think of a price that we would be happy with now that we had a good idea of similar properties, and get back to her in our own time. By now, we really felt we could trust Laura and called back with an idea of a price. She too wanted to speak to the rest of the family team and came back with a better offer, which also included paying the solicitor's fees and no other costs! We were over the moon!! Admittedly we were still a little sceptical, perhaps too good to be true, but again we couldn't be more wrong. I posted a set of keys to her on Monday, she called to say the Surveyor and her son would view the property on Wednesday, she called back Wednesday afternoon to say all was fine and they were happy with the condition, gave me the name of a lawyer she recommended, I called, we went in 3 days later to sign the necessary documents at the solicitors, and the money was in the bank by the end of the week!!!!! We did not even have to clear the remaining furniture, in fact, we did not have to ever visit it again!!! We get married in 4 weeks, have money in the bank to have the best honeymoon ever, and a nice big deposit for our forever home. Will be recommending far and wide, a smashing way to sell your house, particularly in such a changing economic climate. Thank you so much for everything you have done: Friendly, understanding, efficient, fast, fair, and fab!"
  },
      ],
      quizData: {},
      showQuiz: false,
      showContact: false,
      address: {},
      utmCampaign: '',
      utmSource: '',
      utmMedium: '',
      utmMatchType: '',
      utmKeyword: '',
      utmDevice: '',
      seoQuery: '',
      creativeId: '',
      gclid: '',
      headerImageUrl: require("@/assets/houses-bg.jpg"),
      faqs: [
      {
          question: 'WHY SHOULD I USE YOUR COMPANY?',
          answer: 'Thank you for considering our property buying service. We understand that selling your property can be a challenging process, and we\'re here to make it as easy and stress-free as possible. When you choose our company, you can rest assured that you\'re working with a professional and discreet team that is committed to providing you with a fast and efficient service. Unlike traditional buyers, we don\'t rely on mortgages or bank loans to fund our purchases, and we have our own cash reserves to make instant decisions and get the money to you in a timeframe that suits you. Whether you\'re selling due to financial difficulties, a change in lifestyle, or any other reason, we\'re here to help. Our team has extensive experience in the property industry and can offer you a fair and competitive price for your property. We pride ourselves on our transparent and straightforward approach and will guide you through every step of the process. So why choose our company? Because we\'re dedicated to providing you with peace of mind, a fast and professional service, and a fair and competitive cash offer for your property. If you have any further questions or would like to request a cash offer, please don\'t hesitate to contact us.',
          isOpen: false
        },
        {
          question: 'DO YOU REALLY BUY ANY TYPE OF PROPERTY?',
          answer: 'We buy any property type, flats, houses, detached, semi-detached, bungalows etc., regardless of their condition. We are also interested in land, commercial buildings, oddball properties, ugly properties, and derelict properties. We will look at absolutely everything.',
          isOpen: false
        },
        {
          question: 'WILL I HAVE TO PAY ANY FEES?',
          answer: 'No, you won\'t have to pay any fees. Just accept our offer, and that\'s it.',
          isOpen: false
        },
        {
          question: 'MY PROPERTY IS ALREADY ON THE MARKET, WILL YOU STILL BUY IT?',
          answer: 'Yes, we can still buy your property; however, you will need to check the terms and conditions of your agency agreement to see if you will need to pay them any withdrawal fees.',
          isOpen: false
        },
        {
          question: 'I\'M FACING REPOSSESSION, CAN YOU HELP?',
          answer: 'Indeed, being cash buyers, we can stop repossession. As we understand it is a stressful time, we can offer what you need, Speed, Certainty, and Simplicity. We also let you move in a timescale that suits you. We generally allow up to 3 months in the property after we have purchased it.',
          isOpen: false
        },
        {
          question: 'WHAT SETS YOUR SERVICE APART FROM SITES THAT CLAIM TO PURCHASE PROPERTIES FOR 100% MARKET VALUE?',
          answer: 'Our service is different from sites that claim to purchase properties for 100% market value in a few important ways. Firstly, our core business is focused on buying properties quickly and efficiently, and we cater to those who genuinely require our service. We understand that selling a property can be a stressful and time-consuming process, and we aim to make it as easy and hassle-free as possible. On the other hand, other companies that claim to offer 100% market value often use methods such as brokerage or assisted sales (ASA), which can take longer and may involve additional fees. There\'s also no guarantee that your property will sell through these methods. At our company, we offer a fair and competitive cash offer for your property, with no hidden costs or fees. We have our own cash reserves, which means that we can make instant decisions and complete the sale quickly and efficiently. Of course, we also recognise that every property is unique, and we\'re always happy to explore alternative options such as brokerage or ASA if it\'s in your best interest. Our goal is to provide you with a tailored service that meets your specific needs and helps you achieve your property selling goals. If you have any further questions or would like to request a cash offer, please don\'t hesitate to contact us. We\'re committed to providing you with a transparent and straightforward service that you can trust.',
          isOpen: false
        },
      ],
    };
  },
  
  methods: {
    goToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    onAddressSelected(address) {
      this.addressData = address;
      this.showQuiz = true;
    },
    onQuizComplete(quizResults) {
      this.quizData = quizResults;
      this.showQuiz = false;
      this.showContact = true;
    },
    parseUrlParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    this.gclid = urlParams.get('gclid') || '';
    this.utmCampaign = urlParams.get('utm_campaign') || '';
    this.utmSource = urlParams.get('utm_source') || '';
    this.utmMedium = urlParams.get('utm_medium') || '';
    this.utmKeyword = urlParams.get('keyword') || '';
    this.utmDevice = urlParams.get('device') || '';
    this.utmMatchType = urlParams.get('matchtype') || '';
    this.adId = urlParams.get('adid') || '';
    this.adSetId = urlParams.get('adsetid') || '';
    this.seoQuery = urlParams.get('q') || '';
    this.creativeId = urlParams.get('creativeid') || '';
    },
    toggle(index) {
    this.faqs[index].isOpen = !this.faqs[index].isOpen;
  },
  // Move these methods into the `methods` object
  previousReview() {
    if (this.currentReview > 0) {
      this.currentReview--;
    }
  },
  nextReview() {
    if (this.currentReview < this.reviews.length - 1) {
      this.currentReview++;
    }
  },
},
created() {
  this.parseUrlParameters();
},
};
</script>

<style>
.header-container {
  /* Other styles */
  position: relative; /* Add relative positioning */
}

@media screen and (max-width: 640px) {
  .sm\:max-w-sm {
    max-width: 84%;
  }
}



.guaranteed-offer {
  margin: 20px 0;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.guaranteed-offer h2 {
  font-size: 2.5rem; 
  font-weight: bold; 
  margin-bottom: 15px; 
}

.offer-steps {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 20px 0;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 10px;
  flex-basis: 30%; 
  box-sizing: border-box; 
}

.chat-bubble-icon,
.cash-offer-icon,
.bank-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

@media (max-width: 600px) {
  .step {
    flex-basis: 100%;
  }
}

.bg-custom-color {
  background-color: blue;
}

@media (max-width: 640px) {
  .small-device-table {
      font-size: 14px;
    }

  .small-device-table td,
  .small-device-table th {
      padding: 4px 8px;
    }
  }

.small-device-table tfoot {
      font-size: 6px;
}

.star-line {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
}

/* Mobile-specific adjustments */
@media only screen and (max-width: 600px) {
  .flex.items-center.mb-2.px-2.sm\:px-0.pr-6 {
    padding-right: 4px; /* Reduce right padding */
    margin-bottom: 1px; /* Reduce space between items */
  }

  .fas.fa-check.text-green-500.mr-2 {
    margin-right: 8px; /* Reduce space after the icon */
  }
}
</style>

